import React, {Component, useState} from 'react';

import './AutoSearchInput.css';

const AutoSearchInput = (props) => {
 const [ state, setState ] = useState(
   {
     dataList: props.data,
     showAutoSearchFields: false,
     selectedValue: props.defaultSelected,
   }
 );

  const handleFocusIn = () => {
    setState({
      ...state,
      showAutoSearchFields: true
    });
  };

  const hideAutoSearchFields = () => {
    setState({
      ...state,
      showAutoSearchFields: false
    });
  };

  const setSelected = (val) => {
    setState({
      ...state,
      selectedValue: val,
      showAutoSearchFields: false
    });
    props.onSelected(val);
  };

  const handleInput = (event) => {
    const val = event.target.value;
    if (!val) {
      setState({
        ...state,
        dataList: props.data
      });
    }
    const filteredData = props.data.filter((item) => {
      return item.text.toLowerCase().indexOf(val.toLowerCase()) !== -1;
    });
    setState({
      ...state,
      dataList: filteredData
    });
  };

    const { placeholder, label, prefixCode, className } = props;
    const {
      showAutoSearchFields,
      dataList,
      selectedValue,
    } = state;
    return (
      <React.Fragment>
        <div
          className={`makeFlex column inputFieldContainer autoSearch ${
            showAutoSearchFields ? 'activeField' : ''
          }`}
          onMouseEnter={handleFocusIn}
          onMouseLeave={hideAutoSearchFields}
        >
          <label className="latoBold appendBottom15 font14 defaultGreyText">
            {label}
          </label>
          <span className="arrow arrow-down-wide" />
          <input
            placeholder={placeholder}
            value={selectedValue.text}
            className={`inputField ${
              prefixCode ? 'prefixed' : ''
            } ${className}`}
            readOnly
          />
          {showAutoSearchFields && (
            <React.Fragment>
              <div className="autoSearchContainer">
                <span className="arrow arrow-down-wide" />
                <input
                  type="text"
                  className="font14 searchInputField"
                  placeholder="Search..."
                  autoFocus
                  onInput={(event) => handleInput(event)}
                />
                <ul className="autoSearchList">
                  {dataList.map((item) => {
                    return (
                      <li
                        onClick={() =>
                          setSelected(item)
                        }
                        key={item.text}
                      >
                        {item.text}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </React.Fragment>
          )}
        </div>
        {
          showAutoSearchFields &&
                    <div
                      className="backdrop"
                      onClick={hideAutoSearchFields}
                    />
        }
      </React.Fragment>
    );
  }

  export default AutoSearchInput;
